import ApiService from '@/services/api.service'

export default defineNuxtPlugin((_nuxt) => {
  const app = useNuxtApp()
  const apiService = new ApiService(app)

  return {
    provide: {
      apiService,
    },
  }
})
